// @flow
import moment from 'moment';

import LegacyDispatcher from 'app/lib/legacyDispatcher';
import Database from 'app/lib/Database';
import BaseStore from 'app/stores/BaseStore';

type Build = {

};

type Project = {
  id: string
};

type Query = {
  page?: number,
  perPage?: number
};

declare var jQuery: {
  ajax: (options: { url: string, success: (builds: Array<Build>) => mixed }) => mixed
};

export default class BuildStore extends BaseStore {
  database: Database;
  project: Project;
  query: Query;

  constructor(project: Project, builds: Array<Build>, query: Query) {
    // Call super on the parent store
    super();

    // Create a database and seed it with data
    this.database = new Database(builds);
    this.project = Database.parse(project);
    this.query = Database.parse(query);

    // Handle new builds (but only if we're on the first page of the
    // builds list)
    if (!this.query.page || (this.query.page === 1)) {
      // If we receive a build:* for a build that we don't know about yet,
      // we should check to see if it matches our store, and then add it to the
      // database. We only do this if we're on the first page however.
      LegacyDispatcher.on("build:created build:started build:finished", ({ fetcher }) => {
        fetcher({ truncate_jobs: true })
          .then((build) => {
            if (!this.project || (this.project.id === build.project.id)) {
              this.reload();
            }
          })
          .catch(() => {});
      });
    }
    // Do nothing

    // If we receive a build updated event, and the build is in our database,
    // update it and emit a change event.
    LegacyDispatcher.on("build:started build:updated build:finished", ({ id, fetcher }) => {
      if (this.database.exists(id)) {
        fetcher({ truncate_jobs: true })
          .then((build) => {
            const parsedBuild = Database.parse(build);
            if (this.database.find(parsedBuild.id)) {
              return this._loadAndEmit(parsedBuild);
            }
          })
          .catch(() => {});
      }
    });
  }
  // Do nothing

  // Return all the builds sorted by updated at.
  all() {
    // Sort the builds by created at desc (newest first)
    const sortedBuilds = this.database.all().sort((buildA, buildB) => moment(buildB.createdAt).unix() - moment(buildA.createdAt).unix());

    // Only show the right number of builds.
    return sortedBuilds.slice(0, this.query.perPage);
  }

  reload(url: ?string) {
    if (!url) {
      url = location.href.replace(/(\?|$)/, '.json$1');
    }

    return jQuery.ajax({
      url,
      success: (builds) => {
        this.database.load(builds);
        this.emit("change");
      }
    });
  }

  _loadAndEmit(build: Build) {
    this.database.load(build);
    this.emit("change");
  }
}
